import { DockProps } from './index.types';

export function useDockController(_props: DockProps) {
  return {};
}
